<template>
  <portal to="sidebar-menu">
    <div>
      <slot></slot>
    </div>
  </portal>
</template>
<script>

  export default {
    name: 'job-left-menu'
  }
</script>
<style>
</style>
